import { CollapsibleDetailsSection } from '../../components';
import { generatePlanGeneralData } from '@shared/data/mockSubscriptionPlanDetails';
import type { Plan } from '@/features/subscriptions/types/plans/plan.types';

interface GeneralSectionProps {
  isExpanded?: boolean;
  onToggle?: () => void;
  isDetailView?: boolean;
  planData?: Plan;
  className?: string;
}

export const GeneralSection = ({
  isExpanded,
  onToggle,
  isDetailView = false,
  planData,
  className,
}: GeneralSectionProps) => {
  // Use real data if available, otherwise fall back to mock data
  const generalDetails = planData
    ? generatePlanGeneralData(planData)
    : generatePlanGeneralData();

  return (
    <CollapsibleDetailsSection
      title="General"
      details={generalDetails}
      isExpanded={isExpanded ?? true}
      onToggle={onToggle ?? (() => {})}
      visibleCount={isDetailView ? generalDetails.length : 4}
      isDetailView={isDetailView}
      emptyMessage="No general details available"
      className={className}
    />
  );
};
